<script setup lang="ts">
import { storeToRefs } from "pinia";
import { useUiStore } from "@/stores/ui";
import ToastView from "@/components/shared/ToastView.vue";

const uiStore = useUiStore();
const { toasts } = storeToRefs(uiStore);

const onToastInput = (value, id) => {
  if (!value) {
    uiStore.removeToastById(id);
  }
};
</script>

<template>
  <div class="toast-handler">
    <ToastView
      v-for="(toast, index) in toasts"
      :key="index"
      v-model="toasts[index].isVisible"
      :type="toast.type"
      @input="(value) => onToastInput(value, toast.id)"
    >
      {{ toast.message }}
    </ToastView>
  </div>
</template>

<style lang="scss" scoped>
.toast-handler {
  position: fixed;
  bottom: 24px;
  left: 24px;
  z-index: 1000;
}

:deep(.v-snack) {
  position: relative !important;
  margin: 0 0 10px;
  transition: none;
}
</style>
